export class SocialMedia {
    id?: number;
    branchCode?: number;
    instagram?: string;
    telegram?: string;
    twitter?: string;
    facebook?: string;
    whatsApp?: string;
    website?: string;
    constructor() {
        this.instagram="";
        this.telegram="";
        this.twitter="";
        this.facebook="";
        this.whatsApp="";
        this.website="";
    }
}